import { IApplicationState } from '../../types/redux';

export const selectGeoPath = (state: IApplicationState): string => {
  return state.location.geoPath;
};
